import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Grid,
  ButtonBase,
  Skeleton,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Img } from 'pages/vendor/profileVendor/ProfileVendorStyle';
import { businessTypeData } from 'utils/enumObj';
import star from 'assets/images/smStar.svg';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import deactive from 'assets/images/deActivate.svg';
import block from 'assets/images/block.svg';
import profilePic from 'assets/images/SubVendorLogo.svg';
import location from 'assets/images/smLocationIcon.svg';
import './SubHeader.scss';
import OfficeBlue from "assets/images/OfficeBlue.svg";

function SubHeader(props) {
  const details = props?.details;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOnError = (e) => {
    e.target.src = profilePic;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (actionType) => {
    setSelectedItem(actionType);
    switch (actionType) {
      case 'Deactivate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Block':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Activate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Unblock':
        props?.onClickStatusIcon(actionType);
        break;
      default:
        // Handle other menu item actions if needed
        break;
    }
    handleMenuClose();
  };
  const getConditionalMenuItems = () => {
    const status = details?.status || '';

    switch (status.toLowerCase()) {
      case 'active':
        if (props?.tabName === 'customer') {
          return ['Block'];
        } else {
          return ['Deactivate', 'Block'];
        }
      case 'inactive':
        return ['Activate', 'Block'];
      case 'blocked':
        return ['Unblock'];
      default:
        return [];
    }
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked':
        return block;
      case 'block':
        return block;
      case 'edit':
        return editmore;
      case 'deactivate':
        return deactive;
      case 'delete':
        return deleteicon;
      case 'unblock':
        return block;
      case 'activate':
        return deactive;
      default:
        return editmore;
    }
  };

  return (
    <Grid
      container
      item
      md={props?.type === 'Vehicle' ? 11.9 : 8.3}
      sm={12}
      direction="column"
      spacing={2}
      className="subHeaderShadow height270"
    >
      {props?.loader ? (
        <Skeleton variant="rounded" className='skeltonHeight270'/>
      ) : (
        <div>
          <Grid item className="profileVendor">
            <Grid item container direction="row" justifyContent="space-between">
              <Grid item>
                <ButtonBase className="vendorPic">
                  <Img
                    alt="complex"
                    src={details?.avtar ? details?.avtar?.url : profilePic}
                    onError={handleOnError}
                    className="borderRounded height100 width100 backgroundWhite cursorDefault"
                  />
                </ButtonBase>
              </Grid>
              <Grid item>
                <ButtonBase>
                  <div>
                    {(props?.type !== 'Vehicle') && (details?.status?.toLowerCase() !== 'pending') && props?.tabName !== 'compliance' && props?.statusChange &&
                      details?.status?.toLowerCase() !== 'pending' && (
                        <IconButton
                          onClick={handleMenuOpen}
                          className="colorWhite"
                        >
                          <MoreVertIcon />
                        </IconButton>
                      )}

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      {getConditionalMenuItems().map((menuItem, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleMenuItemClick(menuItem)}
                        >
                          <span className="mr10 alignItem">
                            <img src={moreIconSrc(menuItem)} alt={menuItem} />
                          </span>
                          <Typography className="font16 fw500">
                            {menuItem}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                </ButtonBase>
              </Grid>
            </Grid>

            <Grid container direction="row" justifyContent='space-between' alignItems='flex-start' className="nameRatingWrapper">
              <Grid item xs>
                <Typography
                  gutterBottom
                  className="font20 fw600 ml40 marginTop"
                  variant="subtitle1"
                  component="div"
                >
                  {details?.name ? details?.name : details?.companyName ? details?.companyName : details?.complianceName ? details?.complianceName : details?.carModel ? details?.carModel : (details?.firstName || details?.lastName) ? `${details?.firstName || ''} ${details?.lastName || ''}`.trim() : 'Not Available'}
                </Typography>
                {details?.companyName && (
                  <Typography
                    className="font14 fw500 ml40 mt5"
                    variant="body2"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <img src={OfficeBlue} alt="company" className="mr10" style={{ width: '16px', height: '16px' }} />
                    {details?.companyName}
                  </Typography>
                )}
                <div className="ratingWrapper ml40">
                  {details?.rating && (
                    <span className="fw400 font14">
                      <img
                        src={star}
                        alt="star"
                        className="width16 mr5"
                      />
                      {details?.rating}
                    </span>
                  )}
                </div>
                {(details?.city || details?.location || details?.DemandProfile?.location || details?.regNumber) && (
                  <div className="locationWrapper ml40 mt10">
                    <Typography
                      className="font14 fontNormal colorGrey"
                      variant="body2"
                    >
                      <span className="locationIcon">
                        {props?.type !== 'Vehicle' && (
                          <img src={location} alt="location" className="mr10" />
                        )}
                      </span>
                      {details?.city
                        ? details?.city
                        : details?.location
                        ? details?.location
                        : details?.DemandProfile?.location
                        ? details?.DemandProfile?.location
                        : details?.regNumber
                        ? details?.regNumber
                        : 'Not Available'}
                    </Typography>
                  </div>
                )}
              </Grid>
              <Grid item className="mr10">
                {(details?.status || details?.isApproved) &&
                  (details?.status !== null ||
                    details?.isApproved !== null) && (
                    <Typography
                      className={`profileButton ${
                        details?.status
                          ? details?.status.toLowerCase() + 'Status'
                          : details?.isApproved.toLowerCase() + 'Status'
                      }`}
                    >
                      {details?.status
                        ? details?.status
                        : details?.isApproved
                        ? details?.isApproved
                        : 'Not Available'}
                    </Typography>
                  )}
              </Grid>
              <Grid item className="mr10">
                {details?.businessType === businessTypeData?.both &&
                  <Typography className='colorPrimary flex businessTypeWrapper'>
                    <Typography className='mr10 font16'>Public</Typography>
                    <Typography className='font16'>Corporate</Typography>
                  </Typography>
                }
                {details?.businessType === businessTypeData?.coorporate &&
                  <Typography className='colorPrimary flex businessTypeWrapper'>
                    <Typography className='font16'>Corporate</Typography>
                  </Typography>
                }
                {details?.businessType === businessTypeData?.public &&
                  <Typography className='colorPrimary flex businessTypeWrapper'>
                    <Typography className='font16'>Public</Typography>
                  </Typography>
                }
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </Grid>
  );
}

export default SubHeader;
